import { render, staticRenderFns } from "./BoxplotSelection.vue?vue&type=template&id=74301444&"
import script from "./BoxplotSelection.vue?vue&type=script&lang=js&"
export * from "./BoxplotSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports